<template>
    <div class="home">
        <div class="product">
            <div>
                <div>产品分类</div>
                <div v-for="(item,index) in productList" :key="index" @mousemove="getTwoProductList(item,index)"
                    @mouseout="productId=''">
                    <div>
                        <div>{{item.tagName}}</div>
                        <div><i class="el-icon-caret-right"></i></div>
                    </div>
                    <div class="ellipsis">
                        <div v-for="(i,n) in item.byProducts" :key="n">{{i.name}}</div>
                    </div>
                    <div class="productDetails" v-show="productId==item.id" @mousemove="getTwoProductList(item,index)"
                        @mouseout="productId=''">
                        <div>
                            <div v-for="(i,n) in item.byProducts" :key="n">
                                <div>{{i.name}}</div>
                                <div>
                                    <div v-for="(j,x) in i.pushFacMids" :key="x" @click="goProductDetails(item,i,j)">
                                        {{j.facCateName}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <el-carousel height="406px">
                        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                            <div class="banner">
                                <img :src="item.carouselImg">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div v-show="$store.state.orgCode==$store.state.businessNo">
                    <div @click="goRouter('/publish')"></div>
                    <div>
                        <div v-for="item in 12"></div>
                    </div>
                    <div @click="goRouter('/publish_yxmh')"></div>
                    <div>
                        <div v-for="item in 12"></div>
                    </div>
                    <div @click="goRouter('/notice')"></div>
                    <img src="../assets/fb.png">
                </div>
            </div>
        </div>
        <div class="msg_1">
            <div>
                <i class="iconfont icon-shouye-wode-tongzhigonggao"></i>消息通知
            </div>
            <div>
                <div class="ellipsis" v-for="(item,index) in noticeList" :key="index" v-if="index<4"
                    @click="gotNoticeDeatails(item)">
                    {{item.title}}
                </div>
            </div>
        </div>
        <div class="cBox">
            <div>
                <div class="user">
                    <div>
                        <i v-if="!info.avatar" class="iconfont icon-shouye-denglutouxiang"></i>
                        <img v-else :src="$store.state.imgUrl+info.avatar">
                    </div>
                    <div>欢迎来到瑞阳化工</div>
                    <div v-if="!$store.state.userId" class="login">
                        <div @click="goRouter('/login')">立即登录</div>
                        <div @click="goRouter('/register')">注册账号</div>
                    </div>
                    <div v-else class="nickname">{{$store.state.nickname}}</div>
                </div>
                <div class="myOrder cBL" v-if="$store.state.userId">
                    <div>
                        <div><i class="iconfont icon-shouye-wode-dingdan"></i>我的订单</div>
                        <div></div>
                    </div>
                    <div>
                        <div @click="goRouter('/my_order?type=0')"><i
                                class="iconfont icon-shouye-wode-jiaoyizhong"></i>交易中</div>
                        <div @click="goRouter('/my_order?type=2')"><i
                                class="iconfont icon-shouye-wode-wofabude"></i>我发布的</div>
                        <div @click="goRouter('/my_order?type=1')"><i
                                class="iconfont icon-shouye-wode-yiwanchengde"></i>交易完成</div>
                    </div>
                </div>
                <div class="company cBL" v-if="$store.state.userId">
                    <div>
                        <div><i class="iconfont icon-shouye-wode-dingdan"></i>公司认证</div>
                        <div @click="goRouter('/company')">+添加</div>
                    </div>
                    <div>
                        <div v-for="(item,index) in companyList" :key="index">
                            <div v-if="item.isMain=='1'" class="min">主</div>
                            <div v-else class="cong"><i class="el-icon-office-building"></i></div>
                            <div class="ellipsis">{{item.companyName}}</div>
                        </div>
                    </div>
                </div>
                <div class="msg cBL">
                    <div>
                        <div><i class="iconfont icon-shouye-wode-dingdan"></i>通知公告</div>
                        <div @click="goRouter('/notice')">更多</div>
                    </div>
                    <div>
                        <div class="ellipsis" v-for="(item,index) in noticeList" :key="index"
                            @click="gotNoticeDeatails(item)">{{item.title}}</div>
                    </div>
                </div>
            </div>
            <div>
                <!-- 精选推荐 -->
                <div class="boutique">
                    <div class="title">
                        <div>最新发布</div>
                    </div>
                    <div class="list">
                        <div class="item_1" v-for="(commodity,key) in newList" :key="key" @click="goDetails(commodity)">
                            <div>
                                <img v-if="commodity.typeName=='抢购'" src="../assets/home_jp.png">
                                <img v-else src="../assets/home_yxmh.png">
                            </div>
                            <div class="ellipsis">
                                {{commodity.title}}{{commodity.productMsg?'·'+commodity.productMsg:''}}</div>
                            <div class="ellipsis"><i class="iconC el-icon-office-building"></i>{{$store.state.orgName}}
                            </div>
                            <div>总量<span class="blue">{{commodity.amount}}</span>{{commodity.numUnit}}</div>
                            <div v-if="commodity.typeName=='抢购'">
                                <label>底价</label>
                                <span class="red fz22">¥</span>
                                <span v-if="commodity.typeName=='抢购'"
                                    class="red fz32">{{commodity.modeName=='明拍'?commodity.priceOne/1:(commodity.status=='2'?commodity.priceOne/1:'???')}}</span>
                                <span class="red fz16">/{{commodity.unitedTitle}}</span>
                            </div>
                            <div v-if="commodity.typeName=='意向卖货'">
                                <label v-if="commodity.priceOne/1!='0'" s>底价</label>
                                <span class="red fz22" v-if="commodity.priceOne/1!='0'">¥</span>
                                <span v-if="commodity.typeName=='意向卖货'"
                                    class="red fz32">{{commodity.priceOne/1==0?'面议':commodity.priceOne/1}}</span>
                                <span class="red fz16"
                                    v-if="commodity.priceOne/1!='0'">/{{commodity.unitedTitle}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="prodect_banner" @click="goRouter('/product')">
                    <img src="../assets/prodect_banner.jpg">
                </div>
                <!-- 意向卖货 -->
                <div class="yxmh">
                    <div class="box title">
                        <div class="fz18">意向卖货</div>
                        <div class="fz14" @click="goRouter('/shop_yxmh')">查看更多<i class="el-icon-d-arrow-right"></i>
                        </div>
                    </div>
                    <div class="list">
                        <div class="item_2" v-for="(commodity,key) in yxmhList" :key="key"
                            @click="goDetails(commodity)">
                            <div :class="'status_'+commodity.status">
                                <span v-if="commodity.status=='1'">进行中</span>
                                <span v-if="commodity.status=='2'">停售中</span>
                                <span v-if="commodity.status=='3'">已结束</span>
                            </div>
                            <div class="ellipsis">
                                {{commodity.title}}{{commodity.productMsg?'·'+commodity.productMsg:''}}</div>
                            <div>
                                <div class="ellipsis"><i
                                        class="iconC el-icon-office-building"></i>{{$store.state.orgName}}
                                </div>
                                <!-- <div>{{commodity.location}}</div> -->
                            </div>
                            <div>
                                <div>总量<span class="blue">{{commodity.amount}}</span>{{commodity.numUnit}}</div>
                                <div>更新时间 {{commodity.startDate|homeTime}}</div>
                            </div>
                            <div>
                                <label v-if="commodity.priceOne/1!='0'">底价</label>
                                <span class="origin fz22" v-if="commodity.priceOne/1!='0'">¥</span>
                                <span class="origin fz32">{{commodity.priceOne/1=='0'?'面议':commodity.priceOne/1}}</span>
                                <span class="origin fz16"
                                    v-if="commodity.priceOne/1!='0'">/{{commodity.unitedTitle}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 竞拍推荐 -->
                <div class="jptj">
                    <div class="title">
                        <div>竞拍推荐</div>
                        <div class="fz14" @click="goRouter('/shop_auction')">查看更多<i class="el-icon-d-arrow-right"></i>
                        </div>
                    </div>
                    <div class="list">
                        <div class="item_3" v-for="(commodity,key) in auctionList" :key="key"
                            @click="goDetails(commodity)">
                            <div>
                                <div></div>
                                <div class="ellipsis">
                                    {{commodity.title}}{{commodity.productMsg?'·'+commodity.productMsg:''}}</div>
                                <div>
                                    <div>总量<span class="blue">{{commodity.amount}}</span>{{commodity.numUnit}}</div>
                                    <!-- <div>最低购买量<span class="blue">25</span>吨</div> -->
                                </div>
                                <div class="ellipsis"><i
                                        class="iconC el-icon-office-building"></i>{{$store.state.orgName}}
                                </div>
                                <div>开始时间 {{commodity.startDate|homeTime}}</div>
                            </div>
                            <div>
                                <div>
                                    <span class="red fz22">¥</span>
                                    <span
                                        class="red fz32">{{commodity.modeName=='明拍'?(commodity.priceOneNew?commodity.priceOneNew/1:commodity.priceOne/1):(commodity.isPublic=='2'?'???':commodity.status=='2'?(commodity.priceOneNew?commodity.priceOneNew/1:commodity.priceOne/1):'???')}}</span>
                                    <span class="red fz16">/{{commodity.unitedTitle}}</span>
                                    （当前最高价）
                                </div>
                                <div>
                                    竞拍底价
                                    <span
                                        class="green fz20">¥{{commodity.modeName=='明拍'?commodity.priceOne/1:(commodity.status=='2'?commodity.priceOne/1:'???')}}</span>
                                    /{{commodity.unitedTitle}}
                                </div>
                                <div>立即竞拍</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Home",
        data() {
            return {
                yxmhList: [],
                auctionList: [],
                newList: [],
                productList: [],
                productId: '',
                bannerList: [],
                noticeList: [],
                companyList: [],
                info: {
                    isNotCertified: null
                }
            }
        },
        created() {
            this.init();
            if (this.$store.state.userId) {
                this.getCompanyList();
                this.getUser();
            }
        },
        methods: {
            getUser() {
                if (this.$store.state.userId) {
                    this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                        params: {
                            id: this.$store.state.userId,
                            flag: this.$store.state.isPerson?this.$store.state.isPerson:2
                        }
                    }).then(res => {
                        if (res.status == 200) {
                            this.info = res.data;
                        }
                    });
                }
            },
            getCompanyList() {
                let params = {
                    telnum: this.$store.state.telNum,
                    pwd: sessionStorage.getItem('pwd'),
                    clientId: '',
                }

                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/loginMultipleAccounts",
                    params
                }).then(res => {
                    if (res.status == 200) {
                        if (res.flag == 1) {
                            this.companyList = res.data;
                        } else {
                            this.companyList.push(res.data);
                        }
                    }
                });
            },
            goProductDetails(item, i, j) {
                this.$router.push({
                    path: '/product_details',
                    query: j
                })
            },
            getTwoProductList(item) {
                this.productId = item.id;
            },
            gotNoticeDeatails(item) {
                this.$router.push({
                    path: '/notice_details',
                    query: item
                })
            },
            goDetails(commodity) {
                let that = this;
                if (!that.$store.state.userId) {
                    that.goRouter('/login');
                    return;
                }
                commodity.showType = commodity.typeName;
                commodity.biddingMode = commodity.modeName;
                commodity.pendingWay = commodity.modeName;

                if (commodity.showType == '抢购') {
                    if (commodity.biddingMode == '明拍') {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    } else {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    }
                }

                if (commodity.showType == '意向卖货') {
                    if (that.$store.state.userId == commodity.userId) { //卖家
                        that.$router.push({
                            path: '/shop_yxmh_details_sell',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    } else { //买家
                        this.$router.push({
                            path: '/shop_yxmh_details_buy',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    }
                }
            },
            init() {
                this.getAuction();
                this.getYXMH();
                this.getNew();
                this.getProduct();
                this.getBannerList();
                this.getNoticeList();
            },
            getNew() {
                let params = {
                    pageNum: 1,
                    pageSize: 3,
                    brtNum: this.$store.state.orgCode,
                    type: 2,
                    dealType: 'B,YXMH'
                }
                this.getList(params);
            },
            getAuction() {
                let params = {
                    pageNum: 1,
                    pageSize: 6,
                    brtNum: this.$store.state.orgCode,
                    type: 2,
                    dealType: 'B'
                }
                this.getList(params);
            },
            getYXMH() {
                let params = {
                    pageNum: 1,
                    pageSize: 3,
                    brtNum: this.$store.state.orgCode,
                    type: 2,
                    dealType: 'YXMH'
                }
                this.getList(params);
            },
            getList(params) {
                this.request.get(this.$store.state.httpUrl + "new/h5/queryCommodityListTradeH5", {
                    params: params
                }).then(res => {
                    if (res.status == 200) {
                        if (params.dealType == 'B') {
                            this.auctionList = res.data;
                        }
                        if (params.dealType == 'YXMH') {
                            this.yxmhList = res.data;
                        }
                        if (params.dealType == 'B,YXMH') {
                            this.newList = res.data;
                        }
                    }
                });
            },
            getProduct() {
                this.request.get(this.$store.state.ryHttpUrl + "product/getProducts", {
                    params: {
                        businessNo: this.$store.state.orgCode
                    }
                }).then(res => {
                    if (res.status) {
                        this.productList = res.pageData;
                        this.$store.state.productList = res.pageData;
                    }
                });
            },
            getBannerList() {
                this.request.get(this.$store.state.httpUrl + "slideAnnounce/showSlideshow", {
                    params: {
                        businessNo: this.$store.state.orgCode
                    }
                }).then(res => {
                    if (res.code == '200') {
                        this.bannerList = res.data;
                    }
                });
            },
            getNoticeList() {
                this.request.post(this.$store.state.ryHttpUrl + "announcement/ryAnnouncementList", {
                    page: 1,
                    limit: 10,
                    businessNo: this.$store.state.orgCode
                }).then(res => {
                    if (res.code == 200) {
                        this.noticeList = res.data;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .home {
        background: #E5ECF9;
        text-align: left;
    }

    .tab {
        /* height: 150px; */
        /* box-shadow: 0px 3px 7px 0px #D0DFFF; */
        /* padding-top: 20px; */
        box-sizing: border-box;
        background: linear-gradient(90deg, #D50000 0%, #FF6969 100%);
    }

    .tab>div {
        width: 1200px;
        margin: 0 auto;
    }

    .tab>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        /* height: 52px; */
    }

    .tab>div:nth-child(1)>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
    }

    .tab>div:nth-child(1)>div:nth-child(1)>div:nth-child(1) {
        border-right: 1px solid #82AAFF;
        padding-top: 12px;
        padding-right: 20px;
    }

    .tab>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>img {
        width: 100px;
        height: 28px;
    }

    .tab>div:nth-child(1)>div:nth-child(1)>div:nth-child(2) {
        font-size: 20px;
        font-weight: 600;
        color: #5F93FF;
        line-height: 52px;
        padding-left: 20px;
    }

    .tab>div:nth-child(1)>div:nth-child(2) {
        display: flex;
        border: 1px solid #5F93FF;
        border-radius: 10px;
        width: 541px;
        height: 52px;
        box-sizing: border-box;
    }

    .tab>div:nth-child(1)>div:nth-child(2)>div:nth-child(1) {
        width: 450px;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .tab>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>input {
        border: none;
        width: 100%;
        height: 100%;
        padding: 0;
    }

    .tab>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>input::-webkit-input-placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
    }

    .tab>div:nth-child(1)>div:nth-child(2)>div:nth-child(2) {
        width: 92px;
        background: #5F93FF;
        font-size: 16px;
        color: #F3F7FF;
        text-align: center;
        line-height: 50px;
        border-radius: 0 10px 10px 0;
        box-sizing: border-box;
    }

    .tab>div:nth-child(1)>div:nth-child(3) {
        width: 120px;
        height: 52px;
        background: #5F93FF;
        border-radius: 10px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        color: #F3F7FF;
    }

    .tab>div:nth-child(1)>div:nth-child(4) {
        width: 135px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #5F93FF;
        border-radius: 10px;
        line-height: 50px;
        font-size: 16px;
        color: #5F93FF;
        box-sizing: border-box;
        text-align: center;
    }

    .tab>div:nth-child(2) {
        display: flex;
        height: 54px;
        line-height: 54px;
    }

    .tab>div:nth-child(2)>div:nth-child(1) {
        display: flex;
    }

    .tab>div:nth-child(2)>div:nth-child(1)>div {
        font-size: 18px;
        padding: 0 50px;
        cursor: pointer;
        position: relative;
        color: #FFFFFF;
    }

    .tab>div:nth-child(2)>div:nth-child(1)>div:nth-child(1) {
        background: #B80E0E;
    }

    .product {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 24px;
        display: flex;
        justify-content: space-between;
        position: relative;
    }

    .product>div:nth-child(1) {
        width: 240px;
        height: 405px;
        background: #FFFFFF;
        box-shadow: 0px 3px 7px 0px #D0DFFF;
        border-radius: 10px;
        box-sizing: border-box;
        /* position: relative; */
        margin-top: 24px;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .product>div:nth-child(1)>div {
        padding: 16px 20px 0px 20px;
        box-sizing: border-box;
    }

    .product>div:nth-child(1)>div:nth-child(1) {
        width: 240px;
        height: 48px;
        font-size: 16px;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(90deg, #D50000, #EB2B2B);
        border-radius: 10px 10px 0px 0px;
    }

    .product>div:nth-child(1)>div:hover {
        background: #F0F5FF;
    }

    .product>div:nth-child(1)>div>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333333;
    }

    .product>div:nth-child(1)>div>div:nth-child(1)>div:nth-child(2) {
        color: #BFC8DA;
    }

    .product>div:nth-child(1)>div>div:nth-child(2) {
        /* display: flex; */
        margin-top: 14px;
        font-size: 12px;
        color: #999999;
        padding-bottom: 14px;
        border-bottom: 1px solid #D8E5FF;
    }

    .product>div:nth-child(1)>div>div:nth-child(2)>div {
        line-height: 24px;
    }

    .product>div:nth-child(1)>div:last-child>div:nth-child(2) {
        border: none;
    }

    .product>div:nth-child(1)>div>div:nth-child(2)>div {
        margin-right: 8px;
    }

    .product>div:nth-child(2) {
        position: relative;
    }

    .product>div:nth-child(2)>div:nth-child(2) {
        width: 100%;
        height: 88px;
        position: absolute;
        left: 0;
        top: calc(50% - 44px);
        display: flex;
        padding: 0 170px;
        justify-content: space-between;
        box-sizing: border-box;
    }

    .product>div:nth-child(2)>div:nth-child(2)>img {
        position: absolute;
        height: 126px;
        z-index: 11;
    }

    .product>div:nth-child(2)>div:nth-child(2)>div>i {
        color: #FFFFFF;
        font-size: 42px;
    }

    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(1),
    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(3),
    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(5) {
        width: 88px;
        height: 88px;
        background: rgba(234, 234, 234, 0.43);
        border-radius: 50%;
        text-align: center;
        line-height: 110px;
        position: relative;
        z-index: 12;
        cursor: pointer;
    }

    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(2),
    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(4) {
        display: flex;
        justify-content: space-between;
        width: 100px;
        padding: 46px 0;
    }

    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(2)>div,
    .product>div:nth-child(2)>div:nth-child(2)>div:nth-child(4)>div {
        width: 4px;
        height: 4px;
        background-color: #FFFFFF;
        border-radius: 50%;
    }

    .product>div:nth-child(2)>div:nth-child(1) {
        width: 936px;
        /* height: 305px; */
        height: 406px;
        background: #354158;
        border-radius: 10px;
        margin-top: 24px;
        background-image: url(../assets/bannerbg.jpg);
    }

    .product>div:nth-child(2)>div:nth-child(1)>img {
        width: 100%;
        height: 100%;
    }

    .productDetails {
        width: 960px;
        height: 406px;
        position: absolute;
        left: 240px;
        top: 0px;
        top: 24px;
        z-index: 9999;
        padding: 0 0 0 4px;
        box-sizing: border-box;
    }

    .productDetails>div {
        width: 957px;
        height: 406px;
        background: #FFFFFF;
        box-shadow: 0px 3px 7px 0px #D0DFFF;
        border-radius: 0px 0px 10px 0px;
        padding: 0px 30px 24px 30px;
        box-sizing: border-box;
        overflow-y: auto;
    }

    .productDetails>div>div {
        padding-top: 24px;
    }

    .productDetails>div>div>div:nth-child(1) {
        font-size: 14px;
        color: #5283EB;
    }

    .productDetails>div>div>div:nth-child(2) {
        display: flex;
        font-size: 12px;
        color: #666666;
        margin-top: 10px;
        flex-wrap: wrap;
    }

    .productDetails>div>div>div:nth-child(2)>div {
        margin-right: 8px;
        cursor: pointer;
    }

    .productDetails>div>div>div:nth-child(2)>div:hover {
        color: #5283EB;
    }

    /* .product>div:nth-child(2)>div:nth-child(2) {
        width: 936px;
        height: 84px;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .product>div:nth-child(2)>div:nth-child(2)>div {
        width: 295px;
        height: 83px;
        background: linear-gradient(90deg, #7395F4 0%, #AAC9FA 100%);
        border-radius: 10px;
    } */

    .banner {
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .banner>img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .msg_1 {
        width: 1200px;
        height: 72px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 8px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 10px;
    }

    .msg_1>div:nth-child(1) {
        width: 150px;
        height: 56px;
        line-height: 56px;
        background: linear-gradient(90deg, #FF8A26 0%, #FFB17D 100%);
        border-radius: 10px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
    }

    .msg_1>div:nth-child(1)>i {
        color: #FFFFFF;
        font-size: 24px;
        vertical-align: middle;
        margin-right: 12px;
    }

    .msg_1>div:nth-child(2) {
        display: flex;
        width: calc(100% - 180px);
        flex-wrap: wrap;
        position: relative;
    }

    .msg_1>div:nth-child(2)::after {
        content: ' ';
        width: 1px;
        height: 50%;
        background-color: #CCCCCC;
        position: absolute;
        left: 50%;
        top: 25%;
    }

    .msg_1>div:nth-child(2)>div {
        width: 50%;
        line-height: 28px;
        position: relative;
        padding-left: 28px;
        height: 28px;
        box-sizing: border-box;
        color: #666666;
        cursor: pointer;
    }

    .msg_1>div:nth-child(2)>div:hover {
        color: #D50000;
    }

    .msg_1>div:nth-child(2)>div::after {
        content: ' ';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #D50000;
        position: absolute;
        left: 12px;
        top: calc(50% - 2px);
    }

    .cBox {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
    }

    .cBox>div:nth-child(1),
    .cBox>div:nth-child(1)>div {
        width: 240px;
    }

    .cBox>div:nth-child(1)>div {
        background: #FFFFFF;
        border-radius: 10px;
        margin-bottom: 20px;
    }

    .cBox>div:nth-child(1)>.cBL {
        padding: 0 24px;
        box-sizing: border-box;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1) {
        height: 48px;
        line-height: 46px;
        border-bottom: 1px solid #CCCCCC;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(1) {
        color: #D50000;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(1)>i {
        font-size: 16px;
        margin-right: 12px;
        vertical-align: middle;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(2) {
        color: #666666;
        cursor: pointer;
    }

    .user {
        width: 240px;
        height: 172px;
        text-align: center;
        padding-top: 24px;
        box-sizing: border-box;
    }

    .user>div:nth-child(1) {
        width: 54px;
        height: 54px;
        background: #FFEFE2;
        border-radius: 50%;
        margin: 0 auto;
        text-align: center;
        line-height: 54px;
        box-sizing: border-box;
    }

    .user>div:nth-child(1)>i {
        font-size: 24px;
        color: #D50000;
    }

    .user>div:nth-child(1)>img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
    }

    .user>div:nth-child(2) {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
    }

    .user>.login {
        display: flex;
        justify-content: space-around;
        margin-top: 16px;
    }

    .user>.login>div {
        font-size: 14px;
        font-weight: 400;
        color: #D50000;
        width: 80px;
        height: 30px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .user>.login>div:nth-child(1) {
        background: rgba(213, 0, 0, 0.13);
        border-radius: 5px;
        line-height: 30px;
    }

    .user>.login>div:nth-child(2) {
        background: #FFFFFF;
        border: 1px solid #D50000;
        border-radius: 5px;
        line-height: 26px;
    }

    .user>.nickname {
        margin-top: 16px;
        text-align: center;
        line-height: 30px;
    }

    .myOrder {
        height: 138px;
    }

    .myOrder>div:nth-child(2) {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .myOrder>div:nth-child(2)>div {
        width: 50%;
        margin-bottom: 16px;
        cursor: pointer;
    }

    .myOrder>div:nth-child(2)>div>i {
        margin-right: 10px;
        font-size: 16px;
        color: #FFA159;
        vertical-align: middle;
    }

    .company>div:nth-child(2) {
        padding-top: 20px;
        padding-bottom: 10px;
    }

    .company>div:nth-child(2)>div {
        display: flex;
        line-height: 20px;
        margin-bottom: 10px;
    }

    .company>div:nth-child(2)>div>.min {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        background: rgba(213, 0, 0, .2);
        border-radius: 50%;
        font-size: 12px;
        color: #D50000;
        margin-right: 10px;
    }

    .company>div:nth-child(2)>div>.cong {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        background: rgba(95, 147, 255, .2);
        border-radius: 50%;
        margin-right: 10px;
    }

    .company>div:nth-child(2)>div>.cong>i {
        font-size: 12px;
        color: #5F93FF;
    }

    .msg>div:nth-child(2) {
        padding-top: 20px;
        padding-bottom: 10px;
    }

    .msg>div:nth-child(2)>div {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding-left: 12px;
        position: relative;
        margin-bottom: 12px;
        cursor: pointer;
    }

    .msg>div:nth-child(2)>div::after {
        content: ' ';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #D50000;
        position: absolute;
        left: 0;
        top: calc(50% - 2px);
    }

    .cBox>div:nth-child(2) {
        width: 936px;
    }

    .boutique {
        padding-bottom: 30px;
    }

    .title {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #D50000;
        height: 39px;
        box-sizing: border-box;
    }

    .title>div:nth-child(1) {
        width: 108px;
        height: 38px;
        line-height: 38px;
        background: linear-gradient(90deg, #D50000 0%, #FF6969 100%);
        border-radius: 0px 20px 0px 0px;
        font-size: 16px;
        text-align: center;
        color: #FFFFFF;
    }

    .title>div:nth-child(2) {
        font-size: 14px;
        cursor: pointer;
    }

    .prodect_banner {
        width: 936px;
        height: 120px;
        border-radius: 10px;
        margin-bottom: 20px;
    }

    .prodect_banner>img {
        width: 936px;
        height: 120px;
        border-radius: 10px;
    }

    .boutique>div,
    .yxmh>div {
        width: 936px;
        margin: 0 auto;
    }

    .list>div {
        cursor: pointer;
        position: relative;
        margin-top: 20px;
    }

    .boutique .list {
        display: flex;
        /* justify-content: space-between; */
    }

    .boutique .list>div {
        width: 288px;
        height: 202px;
        background: #FFFFFF;
        border: 1px solid #CCDDFF;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 24px;
        margin-right: calc(104px / 3);
    }

    .list>div:last-child {
        margin-right: 0 !important;
    }


    .item_1>div {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        text-align: left;
    }

    .item_1>div:nth-child(1) {
        width: 97px;
        height: 85px;
        position: absolute;
        right: -6px;
        top: -6px;
    }

    .item_1>div:nth-child(1)>img {
        width: 97px;
        height: 85px;
    }

    .item_1>div:nth-child(2) {
        font-size: 20px;
        font-weight: 600;
        color: #0D1142;
    }

    .item_1>div:nth-child(3) {
        border-bottom: 1px solid #CCDDFF;
        padding: 18px 0 16px 0;
    }

    .item_1>div:nth-child(4) {
        padding: 14px 0 16px 0;
    }

    .item_1>div:nth-child(5)>span {
        font-weight: bold;
    }

    .yxmh .list {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-between; */
        position: relative;
        z-index: 2;
    }

    .yxmh .list>div {
        width: 288px;
        height: 202px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(34, 86, 193, 0.18);
        border-radius: 10px;
        padding: 28px 26px 0 26px;
        box-sizing: border-box;
        position: relative;
        margin-right: calc(104px / 3);
    }

    .item_2>div {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        text-align: left;
    }

    .item_2>div:nth-child(1) {
        position: absolute;
        right: 0;
        top: 12px;
        width: 72px;
        height: 26px;
        line-height: 26px;
        border-radius: 13px 0px 0px 13px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
    }

    .item_2>.status_1,
    .item_2>.status_1>span {
        color: #729BFF;
        background: #E4EEFF;
    }

    .item_2>.status_2,
    .item_2>.status_2>span {
        color: #FF8C25;
        background: #FFE3A6;
    }

    .item_2>.status_3,
    .item_2>.status_3>span {
        color: #90A4D0;
        background: #E3E8F2;
    }

    .item_2>div:nth-child(2) {
        font-size: 20px;
        font-weight: 600;
        color: #333333;
    }

    .item_2>div:nth-child(3) {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #CCDDFF;
        padding: 18px 0;
    }

    .item_2>div:nth-child(4) {
        display: flex;
        justify-content: space-between;
        padding: 12px 0 24px 0;
    }

    .item_2>div:nth-child(5)>span {
        font-weight: bold;
    }

    .item_2>div>div:nth-child(2) {
        color: #999999;
    }

    .jptj {
        margin-top: 30px;
        padding-bottom: 70px;
    }

    .jptj>div {
        width: 936px;
    }

    .jptj>.list {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-between; */
    }

    .jptj>.list>div {
        font-size: 14px;
        color: #666666;
        margin-right: calc(104px / 3);
    }

    .jptj>.list>div:nth-child(3),
    .jptj>.list>div:nth-child(6) {
        margin-right: 0;
    }

    .item_3 {
        width: 288px;
        height: 362px;
        background-color: #FFFFFF;
        box-shadow: 0px 0px 7px 0px rgba(7, 22, 55, 0.25);
        border-radius: 10px;
        box-sizing: border-box;
    }

    .item_3>div {
        padding: 0 24px;
        box-sizing: border-box;
    }

    .item_3>div:nth-child(1) {
        padding-top: 24px;
        height: 164px;
        background: linear-gradient(0deg, #FFECDB 0%, #FFFFFF 100%);
    }

    .item_3>div:nth-child(1)>div:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
        color: #0C306A;
    }

    .item_3>div:nth-child(1)>div:nth-child(3) {
        display: flex;
        justify-content: space-between;
        margin-top: 22px;
    }

    .item_3>div:nth-child(1)>div:nth-child(3),
    .item_3>div:nth-child(1)>div:nth-child(4),
    .item_3>div:nth-child(1)>div:nth-child(5) {
        margin-bottom: 18px;
    }

    .item_3>div:nth-child(2) {
        padding-top: 28px;
    }

    .item_3>div:nth-child(2)>div>span {
        font-weight: bold;
    }

    .item_3>div:nth-child(2)>div:nth-child(2) {
        margin-top: 24px;
    }

    .item_3>div:nth-child(2)>div:nth-child(3) {
        width: 222px;
        height: 46px;
        line-height: 46px;
        margin: 0 auto;
        background: #D70606;
        border-radius: 8px;
        text-align: center;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/home.vue